export abstract class Eq<T> {
  public abstract equals(other: T): boolean;
}
export abstract class StringId {
  public abstract stringId(): string;
}
export abstract class Comparable<T> extends Eq<T> {
  public abstract greaterThan(other: T): boolean;
  public abstract lessThan(other: T): boolean;

  public static compare<T extends Comparable<T>>(a: T, b: T): number {
    if (a.greaterThan(b)) {
      return 1;
    } else if (a.lessThan(b)) {
      return -1;
    } else {
      return 0;
    }
  }
}

/**
 * Comparator function that sorts descending by default.
 * @param order "asc" = ascending, "desc" = descending
 */
export function comparator<T extends Comparable<T>>(order?: 'asc' | 'desc') {
  return (left: T, right: T): number => {
    if (left.greaterThan(right)) {
      if (order === 'asc') {
        return 1;
      }
      return -1;
    } else if (left.lessThan(right)) {
      if (order === 'asc') {
        return -1;
      }
      return 1;
    } else {
      return 0;
    }
  };
}
